export default __webpack_public_path__ + "static/media/Bracers of Erlik.ba1a2136.jpg";